export abstract class ColorTypeStrings {
  static types : {[key: number]: string} = {
    1: 'Contínua',
    2: 'Discreta',
    3: 'Constante'
  }
}